import React, { useState, useEffect } from "react";
import AlsReport from "../researchData/speechStudy/charts/AlsReport";
import AllDemographicGraph from "../researchData/speechStudy/charts/AllDemographicGraph";
import moment from "moment";
import Box from "../../components/dashboard/Box";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";
import $ from "jquery";

const SpeechStudy = () => {
  const [dashboardCount, setDashboardCount] = useState([]);
  const [loading, setLoading] = useState(false);
  const [getActiveLink, setGetActiveLink] = useState(true);

  useEffect(() => {
    if ($(window).width() < 600) {
      $("#sidebar").removeClass("show-sidebar").addClass("hide-sidebar");
    } else {
      $("#sidebar").removeClass("hide-sidebar").addClass("show-sidebar");
    }
    getDashboardData();
  }, []);

  const getDashboardData = () => {
    setLoading(true);
    Bridge.dashboard
      .getDetails()
      .then((result) => {
        if (result.status == "1") {
          console.log("results----->", result);
          let mgh_last_updated_date = result.mgh_last_updated_date
            ? result.mgh_last_updated_date.split("T")[0]
            : "";
          mgh_last_updated_date = mgh_last_updated_date
            ? moment(mgh_last_updated_date).format("MM/DD/YYYY")
            : "---";
          let obj = {
            no_of_modality_ids: result.no_of_modality_ids,
            status: result.status,
            total_accounts_count: result.total_accounts_count,
            total_sessions: result.total_sessions,
            total_participants: result.total_participants,
            last_30_days_session: result.last_30_days_session,
            person_with_als: result.person_with_als,
            person_controls: result.person_controls,
            total_study_completed: result.total_study_completed,
            mgh_last_updated_date: mgh_last_updated_date,
            active_person_with_als: result.active_als,
            active_accounts: result.active_accounts,
            active_controls: result.active_controls,
            active_speech_participants: result.active_speech_participants,
            not_active_speech_participants:
              result.not_active_speech_participants,
          };
          setDashboardCount(obj);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  return (
    <div>
      <div>
        <p
          style={{
            position: "relative",
            fontSize: 32,
            fontFamily: "Open Sans",
            fontWeight: "bold",
            color: "#1A4F83",
            textAlign: "start",
          }}
          className="mb-4"
        >
          {Strings.speechStudy}
        </p>
        <p
          style={{
            position: "relative",
            fontSize: 20,
            fontFamily: "Open Sans",
            fontWeight: "bold",
            color: "#1A4F83",
            textAlign: "start",
          }}
          className="mb-4 block-heading"
        >
          {Strings.realTimeStatastics}
        </p>
      </div>
      <div
        style={{
          backgroundColor: "white",
          padding: "2%",
          borderRadius: "19px",
          maxWidth: "100%",
          alignItems: "center",
        }}
      >
        <div className="row" style={{ padding: "2%" }}>
          <p
            style={{
              position: "relative",
              fontSize: 20,
              fontFamily: "Open Sans",
              fontWeight: "bold",
              color: "#1A4F83",
              textAlign: "start",
            }}
            className="mb-4 block-heading"
          >
            Status: Ongoing
          </p>
          <div className="col-lg-3">
            <a
              href="/participants/speech?filter_status=All"
              style={{
                fontFamily: "Open Sans",
                fontWeight: "regular",
                fontSize: "18",
              }}
              className={`active-links ${getActiveLink ? "active" : ""}`}
            >
              <Box
                title="Total Participants"
                count={dashboardCount.total_participants||0}
                getActiveLink={getActiveLink}
              />
            </a>
          </div>
          <div className="col-lg-3">
            <a
              href="/participants/speech"
              style={{
                fontWeight: "regular",
                fontSize: "18",
              }}
              className={`active-links ${getActiveLink ? "active" : ""}`}
            >
              <Box
                title="Active Participants"
                count={dashboardCount.active_speech_participants||0 }
                getActiveLink={getActiveLink}
              />
            </a>
          </div>
        </div>
        <hr style={{ width: "94%", margin: "0 auto" }} />
        <div className="row" style={{ padding: "2%" }}>
          <div className="col-lg-12">
            <AlsReport />
          </div>
        </div>
        <hr style={{ width: "94%", margin: "0 auto" }} />
        <div className="row" style={{ padding: "2%" }}>
          <div className="col-lg-12">
            <AllDemographicGraph />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpeechStudy;
